import React from 'react';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MetricCardProps } from '@shared/models/charts/metric-card.model.ts';

const MetricCard: React.FC<MetricCardProps> = ({
  icon,
  arrowIcon,
  title,
  value,
  percent,
  percentTextColor,
  hideTrend = false
}) => {
  const { t } = useTranslation();

  const isNotAvailable = percent === 'N/A';
  const tooltipTitle = isNotAvailable
    ? t('analytics_percent_not_available_tooltip')
    : undefined;

  return (
    <div className="inline-flex w-full h-[142.5px] min-w-124 flex-col bg-(--white) p-6 rounded-2xl shadow-[0_4px_16px_0_rgba(0,0,0,0.1)] max-lg-xl:h-[106.5px] max-lg-xl:p-3.5 max-lg-xl:min-w-98">
      <div className="flex gap-4 items-start w-full min-w-0">
        {icon && (
          <img
            src={icon}
            alt={t(title)}
            className="w-17.5 h-17.5 shrink-0 max-lg-xl:w-15 max-lg-xl:h-15"
          />
        )}

        <div className="flex flex-col flex-1 min-w-0">
          <p className="text-base font-bold text-(--blue-4) leading-6 max-lg-xl:font-medium max-lg-xl:leading-4.5">
            {t(title)}
          </p>

          <p className="text-[31px] font-normal text-[rgba(16,24,40,1)] leading-10.25 max-lg-xl:text-[20px]">
            {value}
          </p>

          {!hideTrend ? (
            <div className="flex items-center gap-0.75 w-fit bg-(--white) rounded-[50px] mt-2.5 max-lg-xl:mt-0">
              {arrowIcon && (
                <img src={arrowIcon} alt="Arrow" className="w-[11.5px] h-2.75" />
              )}

              <Tooltip title={tooltipTitle}>
                <span
                  style={{ color: percentTextColor }}
                  className="text-[13px] font-semibold max-lg-xl:font-medium"
                >
                  {percent}
                </span>
              </Tooltip>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
